'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  /**
   * Callback fired when the Input's value is changed
   *
   * function(event: object) => void
   */
  onChange: _propTypes2.default.func.isRequired,
  /** The input's value */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  /** Type of input */
  type: _propTypes2.default.string,
  /** Type of input */
  placeholder: _propTypes2.default.string,
  /** The input's label */
  label: _propTypes2.default.node,
  /** The input's name */
  name: _propTypes2.default.string.isRequired,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the input element */
  inputStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the label element */
  labelStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** The input's max length */
  maxLength: _propTypes2.default.number,
  /** Disables the input */
  disabled: _propTypes2.default.bool,
  /** Display an error message */
  error: _propTypes2.default.node,
  /** Override the styles of the error element */
  errorStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the placeholder */
  placeholderStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Multi line input. If true, a textarea element will be rendered. */
  multiLine: _propTypes2.default.bool,
  /** Multi line input's max visible rows. */
  maxRows: _propTypes2.default.number,
  /** Multi line input's row height. */
  rowHeight: _propTypes2.default.number
};

var defaultProps = {
  style: {},
  inputStyle: {},
  labelStyle: {},
  maxLength: 500,
  disabled: false,
  error: null,
  type: 'text',
  errorStyle: {},
  placeholder: '',
  label: null,
  placeholderStyle: {},
  multiLine: false,
  maxRows: 12,
  rowHeight: 16
};

var displayName = 'Input';

/** General purpose form input */

var Input = function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    _classCallCheck(this, Input);

    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this));

    _this.setTextareaHeight = function () {
      var _this$props = _this.props,
          rowHeight = _this$props.rowHeight,
          maxRows = _this$props.maxRows;
      var height = _this.state.height;


      _this.textarea.style.height = '1px';

      if (_this.textarea.scrollHeight !== height && _this.textarea.scrollHeight < maxRows * rowHeight) {
        if (_this.textarea.scrollHeight < 32) {
          _this.setState({
            height: 32
          });
        } else {
          _this.setState({
            height: _this.textarea.scrollHeight
          });
        }
      }

      _this.textarea.style.height = '100%';
    };

    _this.handleChange = function (event) {
      var onChange = _this.props.onChange;


      _this.setTextareaHeight();

      onChange(event);
    };

    _this.state = {
      height: 32
    };
    return _this;
  }

  _createClass(Input, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var multiLine = this.props.multiLine;


      if (multiLine && this.textarea) {
        this.setTextareaHeight();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onChange = _props.onChange,
          value = _props.value,
          maxLength = _props.maxLength,
          label = _props.label,
          name = _props.name,
          type = _props.type,
          style = _props.style,
          inputStyle = _props.inputStyle,
          labelStyle = _props.labelStyle,
          disabled = _props.disabled,
          error = _props.error,
          errorStyle = _props.errorStyle,
          placeholder = _props.placeholder,
          placeholderStyle = _props.placeholderStyle,
          multiLine = _props.multiLine,
          maxRows = _props.maxRows,
          rowHeight = _props.rowHeight,
          custom = _objectWithoutProperties(_props, ['onChange', 'value', 'maxLength', 'label', 'name', 'type', 'style', 'inputStyle', 'labelStyle', 'disabled', 'error', 'errorStyle', 'placeholder', 'placeholderStyle', 'multiLine', 'maxRows', 'rowHeight']);

      var height = this.state.height;


      var input = _react2.default.createElement('input', _extends({
        className: 'input',
        style: _getStyles2.default.input(error, inputStyle),
        onChange: onChange,
        value: value,
        type: type,
        maxLength: maxLength,
        id: name,
        name: name,
        placeholder: placeholder,
        disabled: disabled
      }, custom));

      if (multiLine) {
        input = _react2.default.createElement(
          'section',
          { style: _getStyles2.default.inputRoot(height) },
          _react2.default.createElement('textarea', _extends({
            className: 'input',
            style: _getStyles2.default.textarea(error, inputStyle),
            onChange: this.handleChange,
            value: value,
            type: type,
            maxLength: maxLength,
            rows: maxRows,
            id: name,
            name: name,
            placeholder: placeholder,
            ref: function ref(node) {
              _this2.textarea = node;
            },
            disabled: disabled
          }, custom))
        );
      }

      return _react2.default.createElement(
        'section',
        { style: _getStyles2.default.root(disabled, style) },
        label ? _react2.default.createElement(
          'label',
          { style: _getStyles2.default.label(labelStyle), htmlFor: name },
          label
        ) : null,
        input,
        _react2.default.createElement(_radium.Style, {
          rules: {
            '.input::placeholder': _getStyles2.default.placeholder(placeholderStyle)
          }
        }),
        error ? _react2.default.createElement(
          'span',
          { style: _getStyles2.default.error(errorStyle) },
          error
        ) : null
      );
    }
  }]);

  return Input;
}(_react.Component);

Input.displayName = displayName;
Input.propTypes = propTypes;
Input.defaultProps = defaultProps;

exports.default = Input;
module.exports = exports.default;